import React from 'react';

const LibraryPage = React.lazy(() => import('../pages/library/LibraryPage/LibraryPage'));

export const PATH_LIBRARY_LIST = '/library';

const PAGE_LIBRARY_LIST = {
  component: LibraryPage,
  path: PATH_LIBRARY_LIST,
};

// IMPORTANT: The order in which the pages are added is important
export default [PAGE_LIBRARY_LIST];
